import type { ReactNode } from 'react';
import Reveal from './Reveal';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'center' | 'left';
}

export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'center',
}: SectionHeadingProps) {
  return (
    <Reveal className={align === 'center' ? 'text-center mx-auto max-w-3xl' : 'max-w-3xl'}>
      {eyebrow && (
        <div className={`flex ${align === 'center' ? 'justify-center' : ''}`}>
          <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#1e1e3f] border border-[#3b3b6b] text-[#a78bfa] text-xs font-medium tracking-[0.18em] uppercase">
            {eyebrow}
          </span>
        </div>
      )}
      <h2 className="mt-5 text-3xl md:text-4xl font-extrabold text-white leading-tight">{title}</h2>
      {description && (
        <p className="mt-4 text-[#a0a0b0] text-base md:text-lg leading-relaxed">{description}</p>
      )}
    </Reveal>
  );
}

export function SectionWrapper({
  children,
  className = '',
  id,
}: {
  children: ReactNode;
  className?: string;
  id?: string;
}) {
  return (
    <section id={id} className={`relative py-24 md:py-32 px-4 md:px-6 ${className}`}>
      <div className="max-w-6xl mx-auto relative z-10">{children}</div>
    </section>
  );
}